import { type FC, type ComponentProps, Children } from 'react';
import { ScrollCarouselProvider } from '../helpers/ScrollCarouselContext.tsx';
import { InnerScrollCarousel } from '../InnerScrollCarousel/InnerScrollCarousel.tsx';
import { type OnSlideChange } from '../types.ts';

export const ScrollCarousel: FC<
    {
        stepSize?: number;
        isInfinite?: boolean;
        autoplay?: boolean;
        autoplaySpeed?: number;
        onSlideChange?: OnSlideChange;
    } & ComponentProps<typeof InnerScrollCarousel>
> = ({ stepSize, isInfinite, autoplay, autoplaySpeed, onSlideChange, ...props }) => {
    // Children.count treats null/undefined/false siblings as slides (e.g. `{trailingItem}`).
    const items = Children.toArray(props.children);
    return (
        <ScrollCarouselProvider
            totalItems={items.length}
            largestItemsToShow={props.itemsToShow}
            stepSize={stepSize}
            isInfinite={isInfinite}
            autoplay={autoplay}
            autoplaySpeed={autoplaySpeed}
            onSlideChange={onSlideChange}
        >
            <InnerScrollCarousel {...props}>{items}</InnerScrollCarousel>
        </ScrollCarouselProvider>
    );
};
